<template>
  <v-sheet
    class="vertical-carrousel pt-0 pt-md-16 pb-16 pb-md-0"
    color="#c6d053"
  >
    <v-container v-if="!smAndDown">
      <div
        class="item"
        v-for="({ img, text, caption }, i) in carrouselData"
        :key="i"
      >
        <div class="item-text white--text PFDinDisplayPro text-center">
          <div v-html="text"></div>

          <span class="item-text-caption" v-if="caption">{{ caption }}</span>
        </div>
        <img class="d-block" :src="img" />
      </div>
    </v-container>
    <v-container class="px-0" v-else>
      <div
        class="item-mobile mt-16 d-block"
        v-for="({ img }, i) in carrouselDataMobile"
        :key="i"
      >
        <img class="d-block" :src="img" />
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    carrouselData: [
      { text: "Algo pequeno,", img: "/img/algoamais/01.png" },
      {
        text: "Mas que faz toda,",
        caption: "diferença:",
        img: "/img/algoamais/02.png",
      },
      { text: "Um sorriso,", img: "/img/algoamais/03.png" },
      { text: "Um obrigado,", img: "/img/algoamais/04.png" },
      { text: "Uma gentileza,", img: "/img/algoamais/05.png" },
      { text: "Pequenos <br> detalhes", img: "/img/algoamais/06.png" },
      { text: "Que <br> transformam o mundo", img: "/img/algoamais/07.png" },
      { text: "Em uma terra prometida!", img: "/img/algoamais/08.png" },
    ],
    carrouselDataMobile: [
      { img: "/img/algoamais/mobile/01.png" },
      { img: "/img/algoamais/mobile/02.png" },
      { img: "/img/algoamais/mobile/03.png" },
      { img: "/img/algoamais/mobile/04.png" },
      { img: "/img/algoamais/mobile/05.png" },
      { img: "/img/algoamais/mobile/06.png" },
      { img: "/img/algoamais/mobile/07.png" },
      { img: "/img/algoamais/mobile/08.png" },
    ],
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical-carrousel {
  .item-mobile img {
    width: 100%;
  }
  .item {
    flex-direction: row-reverse;
    justify-content: space-around;
    align-items: center;
    display: flex;
    margin-bottom: 90px;
    img {
      height: 600px;
      aspect-ratio: 600/600;
      object-fit: contain;
    }
    &-text {
      font-style: normal;
      font-weight: 700;
      font-size: 60px;
      line-height: 72px;
      &-caption {
        font-size: 100px;
        line-height: 120px;
      }
    }
  }
  .item:nth-child(even) {
    flex-direction: row;
  }
}
</style>
